module.exports = __webpack_public_path__ + "a3cc927affcf60fce3dad7a05bf368ae.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/book-stack.png
// module id = 2824
// module chunks = 0